"use client";

import TopBanner from "@/components/TopBanner";
import { useExperienceMode } from "@/context/ExperienceModeContext";
import useElementHeightCssVar from "@/hooks/useElementHeightCssVar";
import cn from "@/lib/cn";
import NavBar from ".";
import { defaultNavBar } from "./default";
import type { NavBarType } from "./types";

interface BaseNavBarProps {
  data?: NavBarType;
}

export default function BaseNavBar({
  data = defaultNavBar,
}: BaseNavBarProps) {
  const navRef = useElementHeightCssVar<HTMLDivElement>("--sticky-nav-height");
  const { cartHeavy } = useExperienceMode();
  const { topBar } = data;

  const topBarVisibility = cn(
    topBar?.show?.mobile === false ? "hidden" : "block",
    topBar?.show?.tablet === false ? "md:hidden" : "md:block",
    topBar?.show?.desktop === false ? "lg:hidden" : "lg:block"
  );

  return (
    <div ref={navRef} className="sticky top-0 z-50">
      <NavBar
        ctaSequence={data.ctaSequence}
        orderCta={data.orderCta}
        phoneCta={cartHeavy ? undefined : data.phoneCta}
        signIn={data.signIn}
        localization={data.localization}
      />
      <div className={topBarVisibility}>
        <TopBanner
          eyebrowText={topBar?.eyebrow}
          mainText={topBar?.copy}
          orderLinkUrl={topBar?.cta?.url}
          orderLinkText={topBar?.cta?.copy}
          prePhoneCopy={topBar?.prePhoneCopy}
          showPhoneCta={!cartHeavy}
        />
      </div>
    </div>
  );
}
